import React, { Component } from "react";
import { Button } from "semantic-ui-react";
import { graphql, gql } from "react-apollo";
import { connect } from "react-redux";
import {
  injectStripe,
  CardElement,
  PaymentRequestButtonElement
} from "react-stripe-elements";
import "./stripeElements.css";
import moment from "moment";
import { cleaningScheduled } from "../../../actions/CleaningActions";
import { navigateTo } from "gatsby-link";

class StripeBookingForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      paymentRequest: null,
      canMakePayment: false
    };
  }
  doStripeStuff = token => {
    const { card } = token;
    this.props.user
      ? this.props
          .newJob({
            variables: {
              id: this.props.user.id,
              // address: `${card.address_line1} ${card.address_line2}`,
              // city: card.address_city,
              // firstName: this.props.firstName,
              // lastName: this.props.lastName,
              // phone: this.props.phone,
              // zip: card.address_zip,
              jobAddress: this.props.address, //add suite number at some point
              jobCity: this.props.city,
              bathrooms: this.props.numBathrooms,
              frequency: this.props.frequency,
              bedrooms: this.props.numBedrooms,
              price: this.props.price / 100,
              // price: 123,
              time: `${moment(this.props.selectedDate).format(
                "YYYY-MM-DD"
              )}T${this.props.selectedTime}`,
              jobZip: this.props.zip,
              cardToken: token.id,
              email: this.props.email
            }
          })
          .then(data => {
            console.log("...booking success");
            this.setState({ loading: false });
            this.props.cleaningScheduled({
              bathrooms: this.props.numBathrooms,
              bedrooms: this.props.numBedrooms,
              frequency: this.props.frequency,

              discount: 0,
              date: moment(
                `${moment(this.props.selectedDate).format("YYYY-MM-DD")}T${this
                  .props.selectedTime}`
              ),
              time: this.props.selectedTime
            });
            navigateTo("/congrats");
          })
          .catch(err => console.error(err))
      : this.props
          .newUser({
            variables: {
              address: `${card.address_line1}`,
              city: card.address_city,
              firstName: this.props.firstName,
              lastName: this.props.lastName,
              phone: this.props.phone,
              zip: card.address_zip,
              jobAddress: this.props.address, //add suite number at some point
              jobCity: this.props.city,
              bathrooms: this.props.numBathrooms,
              bedrooms: this.props.numBedrooms,
              frequency: this.props.frequency,
              // price: this.props.price / 100,
              price: 123,
              time: `${moment(this.props.selectedDate).format(
                "YYYY-MM-DD"
              )}T${this.props.selectedTime}Z`,
              jobZip: this.props.zip,
              cardToken: token.id,
              email: this.props.email,
              password: this.props.password
            }
          })
          .then(data => {
            console.log("...booking success");
            if (data && data.data.signupUser) {
              console.log("setting user...");
              localStorage.setItem("gToken", data.data.signupUser.token);
            }
            this.props.cleaningScheduled({
              bathrooms: this.props.numBathrooms,
              bedrooms: this.props.numBedrooms,
              frequency: this.props.frequency,

              discount: 0,
              date: moment(
                `${moment(this.props.selectedDate).format("YYYY-MM-DD")}T${this
                  .props.selectedTime}`
              ),
              time: this.props.selectedTime
            });
            navigateTo("/congrats");
          })
          .catch(err => console.error(err));
  };
  componentDidMount() {
    const amount = parseInt(this.props.price.toFixed(0), 10);
    const paymentRequest = this.props.stripe.paymentRequest({
      country: "US",
      currency: "usd",
      total: {
        label: "Maid To Clean Jax",
        amount: amount
      }
    });

    paymentRequest.on("token", ({ complete, token, ...data }) => {
      console.log("Received Stripe token: ", token);
      console.log("Received customer information: ", data);
      this.doStripeStuff(token);
      complete("success");
    });
    paymentRequest.canMakePayment().then(result => {
      this.setState({ canMakePayment: !!result });
    });
    this.setState({ paymentRequest: paymentRequest });
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.price !== this.props.price) {
      const amount = parseInt(this.props.price.toFixed(0), 10);
      this.state.paymentRequest.update({
        currency: "usd",
        total: {
          label: "Maid To Clean Jax",
          amount: amount
        }
      });
      // paymentRequest.on("token", ({ complete, token, ...data }) => {
      //   console.log("Received Stripe token: ", token);
      //   console.log("Received customer information: ", data);
      //   this.doStripeStuff(token);
      //   complete("success");
      // });
      // paymentRequest.canMakePayment().then(result => {
      //   this.setState({ canMakePayment: !!result });
      // });
      // this.setState({
      //   paymentRequest: paymentRequest
      // });
    }
  }

  handleSubmit = () => {
    console.log("booking...");
    // e.preventDefault();
    this.setState({ loading: true });
    this.props.stripe
      .createToken({ name: this.props.name })
      .then(({ token }) => {
        console.log("Received Stripe token:", token);
        const { card } = token;
        this.props.user
          ? this.props
              .newJob({
                variables: {
                  id: this.props.user.id,
                  // address: `${card.address_line1} ${card.address_line2}`,
                  // city: card.address_city,
                  // firstName: this.props.firstName,
                  // lastName: this.props.lastName,
                  // phone: this.props.phone,
                  // zip: card.address_zip,
                  jobAddress: this.props.address, //add suite number at some point
                  jobCity: this.props.city,
                  bathrooms: this.props.numBathrooms,
                  frequency: this.props.frequency,
                  bedrooms: this.props.numBedrooms,
                  price: this.props.price / 100,
                  // price: 123,
                  time: `${moment(this.props.selectedDate).format(
                    "YYYY-MM-DD"
                  )}T${this.props.selectedTime}`,
                  jobZip: this.props.zip,
                  cardToken: token.id,
                  email: this.props.email
                }
              })
              .then(data => {
                console.log("...booking success");
                this.setState({ loading: false });
                this.props.cleaningScheduled({
                  bathrooms: this.props.numBathrooms,
                  bedrooms: this.props.numBedrooms,
                  frequency: this.props.frequency,

                  discount: 0,
                  date: moment(
                    `${moment(this.props.selectedDate).format(
                      "YYYY-MM-DD"
                    )}T${this.props.selectedTime}`
                  ),
                  time: this.props.selectedTime
                });
                navigateTo("/congrats");
              })
              .catch(err => console.error(err))
          : this.props
              .newUser({
                variables: {
                  address: `${card.address_line1}`,
                  city: card.address_city,
                  firstName: this.props.firstName,
                  lastName: this.props.lastName,
                  phone: this.props.phone,
                  zip: card.address_zip,
                  jobAddress: this.props.address, //add suite number at some point
                  jobCity: this.props.city,
                  bathrooms: this.props.numBathrooms,
                  bedrooms: this.props.numBedrooms,
                  frequency: this.props.frequency,
                  // price: this.props.price / 100,
                  price: 123,
                  time: `${moment(this.props.selectedDate).format(
                    "YYYY-MM-DD"
                  )}T${this.props.selectedTime}Z`,
                  jobZip: this.props.zip,
                  cardToken: token.id,
                  email: this.props.email,
                  password: this.props.password
                }
              })
              .then(data => {
                console.log("...booking success");
                if (data && data.data.signupUser) {
                  console.log("setting user...");
                  localStorage.setItem("gToken", data.data.signupUser.token);
                }
                this.props.cleaningScheduled({
                  bathrooms: this.props.numBathrooms,
                  bedrooms: this.props.numBedrooms,
                  frequency: this.props.frequency,

                  discount: 0,
                  date: moment(
                    `${moment(this.props.selectedDate).format(
                      "YYYY-MM-DD"
                    )}T${this.props.selectedTime}`
                  ),
                  time: this.props.selectedTime
                });
                navigateTo("/congrats");
              })
              .catch(err => console.error(err));
      })
      .catch(err => {
        console.error(err);
        this.setState({ loading: false });
      });
  };
  render() {
    return (
      <div>
        <CardElement style={{ base: { fontSize: "16px" } }} />

        <Button
          positive
          loading={this.state.loading}
          size="huge"
          fluid
          onClick={() => this.handleSubmit()}
        >
          {" "}
          Book Now
        </Button>
        {this.state.canMakePayment && (
          <div>
            <h3 style={{ margin: "1rem" }}>Or</h3>
            <PaymentRequestButtonElement
              paymentRequest={this.state.paymentRequest}
              className="PaymentRequestButton"
              style={{
                // For more details on how to style the Payment Request Button, see:
                // https://stripe.com/docs/elements/payment-request-button#styling-the-element
                paymentRequestButton: {
                  theme: "light",
                  height: "64px"
                }
              }}
            />
          </div>
        )}
      </div>
    );
  }
}
const myMutation = gql`
  mutation CreateUser(
    $address: String!
    $city: String!
    $firstName: String!
    $lastName: String!
    $phone: String!
    $zip: String!
    $email: String!
    $password: String!
    $bedrooms: Int!
    $bathrooms: Int!
    $frequency: String!
    $jobAddress: String!
    $jobCity: String!
    $price: Float!
    $time: DateTime!
    $jobZip: String!
    $cardToken: String!
  ) {
    signupUser(
      address: $address
      city: $city
      firstName: $firstName
      lastName: $lastName
      phone: $phone
      zip: $zip
      email: $email
      password: $password
      jobAddress: $jobAddress
      jobCity: $jobCity
      price: $price
      frequency: $frequency
      bedrooms: $bedrooms
      bathrooms: $bathrooms
      time: $time
      jobZip: $jobZip
      cardToken: $cardToken
    ) {
      id
      token
    }
  }
`;
const updateMutation = gql`
  mutation createJob(
    $id: ID!
    $jobAddress: String!
    $jobCity: String!
    $price: Float!
    $time: DateTime!
    $jobZip: String!
    $cardToken: String!
    $bathrooms: Int!
    $bedrooms: Int!
    $frequency: String!
  ) {
    createJob(
      address: $jobAddress
      city: $jobCity
      price: $price
      bathrooms: $bathrooms
      bedrooms: $bedrooms
      time: $time
      frequency: $frequency
      userId: $id
      zip: $jobZip
      cardDetails: { cardToken: $cardToken }
    ) {
      id
      address
      city
      price
      bathrooms
      bedrooms
      time
      frequency
    }
  }
`;
const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    cleaningScheduled: cleaning => {
      dispatch(cleaningScheduled(cleaning));
    }
  };
};
StripeBookingForm = graphql(updateMutation, { name: "newJob" })(
  graphql(myMutation, { name: "newUser" })(StripeBookingForm)
);
export default injectStripe(
  connect(null, mapDispatchToProps)(StripeBookingForm)
);



// WEBPACK FOOTER //
// ./src/components/Booking/FormContainer/StripeBookingForm.jsx